import React from 'react'
import Fragment from '../common/fragment'


function FragmentAR(props) {
  return (
    <Fragment pos="r" {...props}>
      <p>
En el fuego de las chimeneas la tierra arde. Los fósiles se transforman en atmósferas.
Disolución geológica de la prehistoria y una combustión incesante del tiempo.
Petróleo: tiempo. El interior de la tierra y el exterior del mundo. El fuego regurgita
las profundidades de un planeta que se desliza. Chimeneas gigantes como dólmenes
del futuro. Stonehenge de metal. Prédicas de combustibles subterráneos.
      </p>
    </Fragment>
  )
}


export default FragmentAR
